import React, { Component, Fragment } from 'react';
import FacebookSvg from './icons/FacebookSvg';
import InstagramSvg from './icons/InstagramSvg';
import YoutubeSvg from './icons/YoutubeSvg';
import TripAdvisorSvg from './icons/TripAdvisorSvg';

export default class ContactInfo extends Component {
  render() {
    return (
      <Fragment>
        <div className="row justify-content-center align-items-center m-2">
          {this.props.info.facebook && (
            <a target="_blank" href={this.props.info.facebook}>
              <FacebookSvg color={'white'} size={30} />
            </a>
          )}
          {this.props.info.insta && (
            <a target="_blank" href={this.props.info.insta}>
              <InstagramSvg color={'white'} size={30} />
            </a>
          )}
          {this.props.info.youtube && (
            <a target="_blank" href={this.props.info.youtube}>
              <YoutubeSvg color={'white'} size={30} />
            </a>
          )}
          {this.props.info.tripAdvisor && (
            <a target="_blank" href={this.props.info.tripAdvisor}>
              <TripAdvisorSvg color={'white'} size={40} />
            </a>
          )}
        </div>
        <div className={`txt-regular ${this.props.textColor} mb-5`}>
          <b>Address: </b>
          {this.props.info.address}
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactInfo.js